import {
    INVALID_ATTACHMENT_ID,
    NOTFOUND_INVOICE_ATTACHMENTS,
} from "constants/snackbarMessage";
import {
    setInvoice,
    setInvoiceAttachments,
} from "redux/actions/generalActions";
import { downloadInvoiceAttachmentApi } from "services/procurement/procurementAPIs";

import alertDispatcher from "./alertsUtils";

export const downloadInvoiceAttachment = (attachment, dispatch) => {
    if (attachment?.id) {
        downloadInvoiceAttachmentApi(attachment.id, dispatch);
    } else {
        alertDispatcher(
            "invoiceAttachments",
            404,
            dispatch,
            INVALID_ATTACHMENT_ID()
        );
    }
};

export const downloadAllAttachments = (attachments, dispatch) => {
    if (attachments.length > 0) {
        attachments.map((attachment) =>
            downloadInvoiceAttachment(attachment, dispatch)
        );
    } else {
        alertDispatcher(
            "invoiceAttachments",
            404,
            dispatch,
            NOTFOUND_INVOICE_ATTACHMENTS()
        );
    }
};
